import { Nullable } from "@/general/custom-types/CustomTypes";

export class RegisterFormModel {
  id?: Nullable<number>;
  number?: Nullable<string>;
  unitSymbol?: Nullable<string>;
  obisCode?: Nullable<number>;

  constructor(
    id?: Nullable<number>,
    number?: Nullable<string>,
    unitSymbol?: Nullable<string>,
    obisCode?: Nullable<number>
  ) {
    this.id = id;
    this.number = number;
    this.unitSymbol = unitSymbol;
    this.obisCode = obisCode;
  }
}
